import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA support
// This enables offline functionality and "Add to Home Screen" prompts
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('Sorta Media is ready to work offline!');
  },
  onUpdate: (registration) => {
    // Optionally show a notification that new content is available
    console.log('New version of Sorta Media available. Refresh to update.');
  }
});
